import { MESApiService } from "@dexteel/mesf-core";

export const getHeatAcquisitionStats = async () => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2("[SWV].[GetHeatAcquisitionStats]", []);
	return resp;
};
